<template>
  <div
    v-if="!!population"
    class="mt-4"
  >
    <div class="sm:flex">
      <label
        class="h-12 block text-center shadow-md my-2 px-0 relative rounded-md sm:w-1/3 w-full"
      >
        <eva-icon
          class="absolute left-0 mt-3 mx-2"
          name="search-outline"
          fill="#282A43"
        />
        <input
          v-model="searchValue"
          class="text-md font-bold h-full w-full px-10 text-purple-500 border-2 border-purple-500 border-opacity-0 focus:border-opacity-100 rounded-md"
          type="text"
          placeholder="Buscar"
        >
      </label>
      <div
        v-if="instancesInfo[instanceID].tags && special"
        class="mb-4 shadow rounded-md p-2 flex mx-1"
      >
        <tag-selector
          class="mb-2 rounded text-lg"
          :tags="instancesInfo[instanceID].tags"
          :unique="true"
          @change="changeTags"
        />
        <div class="ml-5 w-64">
          <div>
            Total en filtro:
          </div>
          <div class="text-blue-500 text-lg font-bold">
            {{ filteredPersons.length }}
          </div>
        </div>
      </div>
    </div>
    <virtual-list
      class="overflow-y-auto days-container"
      style="max-height: 77vh;"
      data-key="id"
      :data-sources="filteredPersons"
      :data-component="itemComponent"
      :extra-props="{ days, todayWithSymptoms, reportedToday, instanceID }"
      @create-population="createPopulation"
      @contact-person="contactPerson"
      @change-symptoms="setSymptoms"
      @open-details="detailsModal"
    />
    <div
      id="symptomsTooltip"
    >
      <span class="tooltip-text w-48 text-white">
        <p class="font-bold text-lg mb-2">Síntomas</p>
        <p
          v-for="label in actualSymptoms"
          :key="label"
          class="border border-red-500 my-1 rounded-sm p-1"
        >{{ symptomsDictionary[label] || label }}</p>
      </span>
    </div>
    <f7-sheet
      class="sheet"
      style="height:auto; --f7-sheet-bg-color: #fff;"
      swipe-to-close
      backdrop
    >
      <f7-block-title
        medium
        class="margin-top"
      >
        Selecciona cuales de las etiquetas de <span class="font-bold text-purple-500">{{ selectedPerson.name }}</span> quieres incluir
      </f7-block-title>
      <div class="mb-10">
        <label
          v-for="tag in selectedPersonTags"
          :key="tag"
          class="custom-label w-64 flex ml-10 cursor-pointer"
          :value="selectedTags[tag]"
          @input="handleInput(tag)"
        >
          <div :class="`flex-shrink-0 rounded-md w-6 h-6 p-1 flex justify-center items-center ${getBackground(tag)}`">
            <input
              type="checkbox"
              class="hidden"
            >
            <svg
              class="w-6 h-6 text-white pointer-events-none"
              viewBox="0 0 172 172"
            ><g
              fill="none"
              stroke-width="none"
              stroke-miterlimit="10"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode:normal"
            ><path d="M0 172V0h172v172z" /><path
              d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
              fill="currentColor"
              stroke-width="1"
            /></g></svg>
          </div>
          <span class="self-center text-base select-none ml-8 text-xl font-bold text-purple-500">
            #{{ tag }}
          </span>
        </label>
      </div>
      <button
        class="disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-full mx-auto my-10"
        @click.prevent="save"
      >
        Crear población
      </button>
    </f7-sheet>
    <f7-sheet
      class="contact-sheet"
      style="height:auto; --f7-sheet-bg-color: #fff;"
      swipe-to-close
      backdrop
    >
      <f7-block-title
        medium
        class="margin-top"
      >
        ¿Cómo deseas contactar a <span class="font-bold text-purple-500">{{ selectedPerson.name }}</span>?
      </f7-block-title>
      <a
        class="external flex justify-start disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-md mx-auto my-1"
        :href="`mailto:${selectedPerson.email}`"
      >
        <eva-icon
          class="cursor-pointer mt-4 mr-2"
          name="email-outline"
          fill="#fff"
        />
        <div>
          email
        </div>
      </a>
      <a
        class="external flex justify-start disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-md mx-auto my-1"
        :href="`tel:${selectedPerson.phoneNumber}`"
      >
        <eva-icon
          class="cursor-pointer mt-4 mr-2"
          name="phone-outline"
          fill="#fff"
        />
        <div>
          Llamada
        </div>
      </a>
      <a
        class="external flex justify-start disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-md mx-auto my-1 mb-10"
        :href="`https://api.whatsapp.com/send?phone=${selectedPerson.phoneNumber}`"
        target="_blank"
        rel="noopener noreferrer"
      >
        <eva-icon
          class="cursor-pointer mt-4 mr-2"
          name="message-square-outline"
          fill="#fff"
        />
        <div>
          Whatsapp
        </div>
      </a>
    </f7-sheet>
    <portal to="modals">
      <modal
        :open="openModal"
        type="custom"
        @close="openModal = false"
      >
        <div slot="content">
          <profile :personID="selectedDetails" />
        </div>
      </modal>
    </portal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import VirtualList from 'vue-virtual-scroll-list'
import PersonDetailsRow from './personDetailsRow'
import tagSelector from '../components/tagSelector'
import profile from '../components/profile'
import moment from 'moment-timezone'
import * as axios from 'axios'
import { search } from 'ss-search'
import Modal from '../components/modal'
export default {
  name: 'PopulationDetails',
  components: {
    VirtualList,
    tagSelector,
    Modal,
    profile,
  },
  props: {
    inView: { type: Boolean, default: true },
    populationID: { type: String, default: '' },
    personIDs: {
      default: function () {
        return []
      },
      type: Array,
    },
    dateTimestamp: {
      default: () => {},
      type: Date,
    },
    special: { type: Boolean, default: false },
  },
  data () {
    return {
      openModal: false,
      selectedDetails: null,
      actualSymptoms: null,
      searchValue: '',
      itemComponent: PersonDetailsRow,
      showChart: false,
      days: [],
      selectedPersonID: null,
      quantity: 2 + 5 * Math.random(),
      selectedPerson: {},
      selectedTags: {},
      selectedPersonTags: [],
      selectedPersonTagIDs: [],
      vlData: {
        items: [],
      },
      activeTag: [],
    }
  },
  computed: {
    filteredPersons () {
      const persons = this.personIDs.map((personID) => {
        return this.persons[this.personsIndexes[personID]]
      }).filter(person => typeof person !== 'undefined')
      const searchKeys = ['name']
      const searchText = this.searchValue
      const searchResults = search(persons, searchKeys, searchText)
      const results = search(searchResults, 'guest ', false) // Remove nonexistan people
      if (this.activeTag.length) {
        const filtered = search(results, [`tagIDs.${this.activeTag}`], true)
        return filtered
      }
      return results
    },
    categories () {
      if (this.instancesInfo[this.instanceID].dictionary.legacyForm) {
        return this.instancesInfo[this.instanceID].dictionary.legacyForm.categories
      }
      return this.instancesInfo[this.instanceID].dictionary.form.categories
    },
    categoryIDs () {
      if (!this.instancesInfo[this.instanceID]) {
        return []
      }
      if (this.instancesInfo[this.instanceID].dictionary.legacyForm) {
        return this.instancesInfo[this.instanceID].dictionary.legacyForm.categoryIDs
      }
      return this.instancesInfo[this.instanceID].dictionary.form.categoryIDs
    },
    symptomsDictionary () {
      const labels = {}
      for (const categoryID of this.categoryIDs) {
        for (const fieldID of this.categories[categoryID].fieldIDs) {
          labels[fieldID] = this.categories[categoryID].fields[fieldID].label
        }
      }
      return labels
    },
    reportedToday () {
      if (this.lastDaysSymptoms[this.dateTimestamp] && this.lastDaysSymptoms[this.dateTimestamp].reported) {
        return this.lastDaysSymptoms[this.dateTimestamp].reported
      } else {
        return []
      }
    },
    todayWithSymptoms () {
      if (this.lastDaysSymptoms[this.dateTimestamp] && this.lastDaysSymptoms[this.dateTimestamp].symptoms) {
        return Object.keys(this.lastDaysSymptoms[this.dateTimestamp].symptoms)
      } else {
        return []
      }
    },
    population () {
      const population = this.populations.find(population => {
        return population.id === this.populationID
      })
      if (population) {
        return population
      }
      return {
        personIDs: this.personIDs,
      }
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      persons: state => state.admin.persons,
      personsIndexes: state => state.admin.personsIndexes,
      populations: state => state.admin.populations,
      lastDaysSymptoms: state => state.admin.lastDaysSymptoms,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    lastDaysSymptoms: function () {
      this.parseSymptoms()
    },
  },
  mounted () {
    this.parseSymptoms()
  },
  methods: {
    detailsModal (personID) {
      this.selectedDetails = personID
      this.openModal = true
    },
    changeTags (newTags) {
      this.activeTag = Object.keys(newTags)
    },
    parseSymptoms () {
      this.days.length = 0
      const activeDay = moment(this.dateTimestamp).tz('America/Bogota').startOf('day')
      this.days.push(activeDay.format('x'))
      for (let i = 0; i < 13; i++) {
        this.days.unshift(activeDay.subtract(1, 'days').format('x'))
      }
      const symptomsCounter = new Map()
      for (const symptomsDay in this.lastDaysSymptoms) {
        if (typeof this.lastDaysSymptoms[symptomsDay].symptoms !== 'undefined') {
          for (const person in this.lastDaysSymptoms[symptomsDay].symptoms) {
            if (this.personIDs.indexOf(person) > -1) {
              for (const symptomLabel of this.lastDaysSymptoms[symptomsDay].symptoms[person]) {
                let actualCounter = symptomsCounter.get(symptomLabel) || 0
                symptomsCounter.set(symptomLabel, ++actualCounter)
              }
            }
          }
        }
      }
    },
    setSymptoms (symptoms) {
      this.actualSymptoms = symptoms
    },
    getBackground (symptomID) {
      if (this.selectedTags[symptomID]) {
        return 'bg-purple-500'
      } else {
        return 'bg-purple-200'
      }
    },
    handleInput (symptomID) {
      if (!this.selectedTags[symptomID]) {
        this.$set(this.selectedTags, symptomID, true)
      } else {
        this.$delete(this.selectedTags, symptomID)
      }
    },
    createPopulation (personID) {
      this.selectedTags = {}
      this.selectedPerson = this.persons[this.personsIndexes[personID]]
      if (!this.selectedPerson.tagIDs) {
        this.$f7.dialog.alert('Esta persona no tiene etiquetas asignadas', 'Sin etiquetas')
        return
      }
      this.selectedPersonTagIDs = Object.keys(this.selectedPerson.tagIDs).filter(tagID => {
        return this.tags[tagID]
      })
      this.selectedPersonTags = this.selectedPersonTagIDs.map(tagID => {
        if (this.tags[tagID]) {
          return this.tags[tagID]
        } else {
          return null
        }
      })
      this.$f7.sheet.open('.sheet')
      // this.$f7.dialog.confirm(`¿Deseas crear una poblacion basada en ${this.selectedPerson ? this.selectedPerson.name : ''}, con las etiquetas: <span style="color: #6C63FF">${this.selectedPersonTags.join(', ')}</span>?`, 'Crear Población', () => {
      //   this.save(tagIDs)
      // })
    },
    contactPerson (personID) {
      this.selectedPerson = this.persons[this.personsIndexes[personID]]
      this.$f7.sheet.open('.contact-sheet')
      // this.$f7.dialog.confirm(`¿Deseas crear una poblacion basada en ${this.selectedPerson ? this.selectedPerson.name : ''}, con las etiquetas: <span style="color: #6C63FF">${this.selectedPersonTags.join(', ')}</span>?`, 'Crear Población', () => {
      //   this.save(tagIDs)
      // })
    },
    async save () {
      this.$f7.sheet.close()
      const tagIDs = this.selectedPersonTagIDs.filter(tagID => {
        return Object.keys(this.selectedTags).indexOf(this.tags[tagID]) !== -1
      })
      try {
        this.$f7.dialog.preloader('Creando población')
        await axios({
          url: '/populations/create',
          method: 'POST',
          data: {
            instanceID: this.instanceID,
            tagIDs: tagIDs,
            originTagIDs: tagIDs,
          },
        })
        this.$f7.dialog.close()
        this.currentTags = []
        this.$emit('close')
      } catch (err) {
        this.$f7.dialog.close()
        console.error(err)
      }
    },
    shouldShowTooltip (day, personID) {
      if (this.lastDaysSymptoms[day] && this.lastDaysSymptoms[day].reported.indexOf(personID) > -1) {
        if (this.lastDaysSymptoms[day].symptoms && this.lastDaysSymptoms[day].symptoms[personID]) {
          return true
        }
      }
      return false
    },
    parsedStyle (day, personID) {
      if (this.lastDaysSymptoms[day] && this.lastDaysSymptoms[day].reported.indexOf(personID) > -1) {
        if (this.lastDaysSymptoms[day].symptoms && this.lastDaysSymptoms[day].symptoms[personID]) {
          switch (this.lastDaysSymptoms[day].symptoms[personID].riskLevel) {
            case 1: return 'bg-yellow-500'
            case 2: return 'bg=orange-500'
            case 3: return 'bg-red-500'
          }
        }
        return 'bg-green-500'
      }
      return 'bg-gray-400'
    },
    parsedDay (day) {
      return moment(day, 'x').add(5, 'hours').format('D')
    },
    parsedStatusStyle (personID) {
      if (this.todayWithSymptoms.indexOf(personID) > -1) return 'background: #FF7570'
      if (this.reportedToday.indexOf(personID) > -1) return 'background: #53dfba'
    },
    handleSelectPerson (personID) {
      if (this.selectedPersonID === personID) {
        this.selectedPersonID = null
        return
      }
      this.selectedPersonID = personID
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../css/_brand";
.days-container::-webkit-scrollbar-track{
  margin: 8px;
  background-color: $bluegray;
}

.days-container::-webkit-scrollbar{
  width: 8px;
  height: 8px;
}
.days-container::-webkit-scrollbar-thumb
{
  cursor: pointer;
  border-radius: 8px;
  background-color: $primary-color;
}
#symptomsTooltip{
  display: none;
  background: #333;
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 4px;
  z-index:9999;
}
#symptomsTooltip[data-show] {
  display: block;
}
</style>
